import React, { FC } from 'react'
import PolicyInput from '../../components/_PolicyInput'
import { IDNameDescriptionItemSelect } from '../../components/_IDNameDescriptionItemSelect';

interface Props {
    policy: any;
    setPremia: (e: any) => void;
    onAdditionalDetailsChange: (field: string, value: any) => void;
    collectionMethodtype: any;
    allBanks: any[];
}

const PaymentAndBankDetails: FC<Props> = ({
    policy,
    setPremia,
    onAdditionalDetailsChange,
    collectionMethodtype,
    allBanks
}) => {


    const getCCNumber = () => {

        return policy && policy.policyAdditionDetails.paymentDetails
            ? policy.policyAdditionDetails.paymentDetails[0]
            : "";
    };


    const setCCNumber = (value: string) => {
        const updated = [...policy.policyAdditionDetails.paymentDetails]; // new array
        updated[0] = value;
        onAdditionalDetailsChange("paymentDetails", updated);
    };


    const getValidityDate = () => {
        return policy && policy.policyAdditionDetails.paymentDetails
            ? policy.policyAdditionDetails.paymentDetails[1]
            : "";
    };

    const setValidityDate = async (value: string) => {

        const updated = [...policy.policyAdditionDetails.paymentDetails]; // new array
        updated[1] = value;
        onAdditionalDetailsChange("paymentDetails", updated);
    };

    const getCVV = () => {
        return policy && policy.policyAdditionDetails.paymentDetails
            ? policy.policyAdditionDetails.paymentDetails[2]
            : "";
    };

    const setCVV = async (value: string) => {

        const updated = [...policy.policyAdditionDetails.paymentDetails]; // new array
        updated[2] = value;
        onAdditionalDetailsChange("paymentDetails", updated);
    };

    const getIdentity = () => {
        return policy && policy.policyAdditionDetails.paymentDetails
            ? policy.policyAdditionDetails.paymentDetails[3]
            : "";
    };

    const setIdentity = async (value: string) => {

        const updated = [...policy.policyAdditionDetails.paymentDetails]; // new array
        updated[3] = value;
        onAdditionalDetailsChange("paymentDetails", updated);
    };

    const getPayerName = () => {
        return policy && policy.policyAdditionDetails.paymentDetails
            ? policy.policyAdditionDetails.paymentDetails[4]
            : "";
    };

    const setPayerName = async (value: string) => {

        const updated = [...policy.policyAdditionDetails.paymentDetails]; // new array
        updated[4] = value;
        onAdditionalDetailsChange("paymentDetails", updated);
    }

    const getPayerPhoneNumber = () => {
        return policy && policy.policyAdditionDetails.paymentDetails
            ? policy.policyAdditionDetails.paymentDetails[5]
            : "";
    };

    const setPayerPhoneNumber = async (value: string) => {

        const updated = [...policy.policyAdditionDetails.paymentDetails]; // new array
        updated[5] = value;
        onAdditionalDetailsChange("paymentDetails", updated);
    }







    return (
        <>
            <div className="parameter-row">
                <div className="tab-content-title section-title">
                    גביה
                </div>
            </div>
            <div className="parameter-row">
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            פרמיה לתשלום
                        </div>
                        <div className="value">
                            {/* <input type='text' value={policy.policyAdditionDetails && policy.policyAdditionDetails.premiumSum} onChange={(e: any) => setPremia(e)} /> */}
                            <PolicyInput
                                type='text'
                                value={policy.policyAdditionDetails && policy.policyAdditionDetails.premiumSum
                                    ? policy.policyAdditionDetails.premiumSum.toString()
                                    : ''}
                                onChange={(e: any) => setPremia(e)}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            מטבע
                        </div>
                        <div className="value">
                            ₪
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            שיטת גביה
                        </div>
                        <div className="value">
                            <IDNameDescriptionItemSelect
                                OnChange={onAdditionalDetailsChange}
                                Id={"collectionMethodType"}
                                Options={{
                                    "-1": { id: -1, name: "בחר שיטת גביה", description: "בחר שיטת גביה" },
                                    ...collectionMethodtype
                                }}
                                Value={policy.policyAdditionDetails && policy.policyAdditionDetails.collectionMethodType != undefined
                                    && policy.policyAdditionDetails.collectionMethodType >= '0' ? policy.policyAdditionDetails.collectionMethodType : '-1'}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>

                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            תשלומים
                        </div>
                        <div className="value">
                            <PolicyInput
                                type='number'
                                value={policy.policyAdditionDetails && policy.policyAdditionDetails.numberOfPayments ?
                                    policy.policyAdditionDetails.numberOfPayments : 1}
                                onChange={(e: any) => onAdditionalDetailsChange('numberOfPayments', e.target.value)}
                            />
                            {/* <input type='number'
                                            className={'policy-input'}
                                            value={policy.policyAdditionDetails && policy.policyAdditionDetails.numberOfPayments ?
                                                policy.policyAdditionDetails.numberOfPayments : 1}
                                            onChange={(e: any) => onAdditionalDetailsChange('numberOfPayments', e.target.value)}
                                            /> */}
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
            </div>
            <div className="parameter-row">
                <div className="tab-content-title section-title">
                    פרטי חשבון
                </div>
            </div>
            <div className="parameter-row">
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            מספר חשבון
                        </div>
                        <div className="value">
                            <PolicyInput type='text'
                                value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankAccountNumber}
                                onChange={(e) => onAdditionalDetailsChange("bankAccountNumber", e.target.value)}
                                style={{ marginLeft: '10px', width: '120px' }}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            שם הבנק
                        </div>
                        <div className="value">
                            <select id="bankNumber" value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankNumber}
                                onChange={(e) => onAdditionalDetailsChange("bankNumber", e.target.value)}>
                                <option value="">בחר</option>
                                {allBanks.map((bank: any, index: number) => (
                                    <option key={index} value={bank.BankName}>
                                        {bank.BankName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            שם הסניף
                        </div>
                        <div className="value">
                            <select id="bankBranchNumber" value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankBranchNumber && policy.policyAdditionDetails.bankBranchNumber.split(',')[0] || ""}
                                onChange={(e) => onAdditionalDetailsChange("bankBranchNumber", e.target.value)}>
                                <option value="">בחר</option>
                                {allBanks.find((bank: any) => bank.BankName === policy?.policyAdditionDetails?.bankNumber) !== undefined &&
                                    allBanks.find((bank: any) => bank.BankName === policy?.policyAdditionDetails?.bankNumber)?.branchCode.map((item: any, index: number) => (

                                        <option key={index} value={item.Branch_Code}>
                                            {"סניף:" + item.Branch_Code + "-  כתובת:" + item.Branch_Address}
                                        </option>
                                    ))}
                            </select>
                        </div>
                    </div>
                    {/* <div className="field">
                                    <div className="title">
                                        סניף
                                    </div>
                                    <div className="value">
                                        <PolicyInput type='text'
                                            value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankBranchNumber}
                                            onChange={(e) => onAdditionalDetailsChange("bankBranchNumber", e.target.value)}
                                            style={{ marginLeft: '10px', width: '120px' }}
                                        />
                                    </div>
                                    <div className='error-message'>
                                    </div>
                                </div> */}
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            שם בעל החשבון
                        </div>
                        <div className="value">
                            <PolicyInput type='text'
                                value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankAccountOwner}
                                onChange={(e) => onAdditionalDetailsChange("bankAccountOwner", e.target.value)}
                                style={{ marginLeft: '10px', width: '120px' }}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>

            </div>

            <div className="parameter-row">
                <div className="tab-content-title section-title">
                    פרטי אשראי
                </div>
            </div>
            <div className="parameter-row">
                                    <div className="parameter-item" style={{ maxWidth: '180px', minWidth: '180px' }}>
                                        <div className="field">
                                            <div className="field-name">
                                                מספר כרטיס
                                            </div>
                                            <div className="value">
                                                <input type="text" id='ccNumber' onChange={(e: any) => setCCNumber( e.target.value)} value={getCCNumber()} placeholder='שדה חובה*' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item" style={{ maxWidth: '100px', minWidth: '100px' }}>
                                        <div className="field">
                                            <div className="field-name">
                                                מס תשלומים
                                            </div>
                                            <div className="value">
                                                <select id="numberOfPayments" value={policy.numberOfPayments} onChange={(e) => onAdditionalDetailsChange("numberOfPayments", e.target.value)} className="select-input">
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                    <option value="7">7</option>
                                                    <option value="8">8</option>
                                                    <option value="9">9</option>
                                                    <option value="10">10</option>
                                                    <option value="11">11</option>
                                                    <option value="12">12</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item" style={{ maxWidth: '100px', minWidth: '100px' }}>
                                        <div className="field">
                                            <div className="field-name">
                                                תוקף
                                            </div>
                                            <div className="value" >
                                                <input type="text" onChange={(e) => {
                                                    let val = e.target.value.replace(/\D/g, ""); // keep only digits
                                                    if (val.length > 2) {
                                                        val = val.slice(0, 2) + "/" + val.slice(2, 4); // insert slash after 2 digits
                                                    }
                                                    setValidityDate(val);
                                                    
                                                }} value={getValidityDate()} placeholder='שדה חובה*' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item" style={{ maxWidth: '100px', minWidth: '100px' }}>
                                        <div className="field">
                                            <div className="field-name">
                                                CVV
                                            </div>
                                            <div className="value" >
                                                <input type="text" onChange={(e: any) => setCVV(e.target.value)} value={getCVV()} placeholder='שדה חובה*' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item" style={{ maxWidth: '150px', minWidth: '150px' }}>

                                        <div className="field">
                                            <div className="field-name">
                                                ת. זהות
                                            </div>
                                            <div className="value" >
                                                <input type="text" onChange={(e: any) => setIdentity(e.target.value)} value={getIdentity()} placeholder='שדה חובה*' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-row">
                                    <div className="parameter-item" style={{ maxWidth: '180px', minWidth: '180px' }}>
                                        <div className="field">
                                            <div className="field-name">
                                                שם מלא
                                            </div>
                                            <div className="value" >
                                                <input type="text" onChange={(e: any) => setPayerName(e.target.value)} value={getPayerName()} placeholder='שדה חובה*' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item" style={{ maxWidth: '180px', minWidth: '180px' }}>
                                        <div className="field">
                                            <div className="field-name">
                                                טלפון
                                            </div>
                                            <div className="value">
                                                <input type="text" onChange={(e: any) => setPayerPhoneNumber(e.target.value)} value={getPayerPhoneNumber()} />
                                            </div>
                                        </div>
                                    </div>

                                </div>

        </>
    )
}

export default PaymentAndBankDetails